<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-04 09:36:33
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-06 15:26:16
 * @Description: 鲸鱼优选 - 标的列表
 -->

<template>
  <div class="project-list-wrapper">
    <div class="nav">
      <h3 class="title"><span>鲸鱼优选</span><i>优质 丰富</i></h3>
      <router-link to="number-one-list" class="more">
        更多<i class="icon iconfont icon-arrow-right"></i>
      </router-link>
    </div>
    <ul class="project-list" v-loading="loading">
      <template v-if="projectList.length > 0">
        <li
          class="project-item"
          v-for="(item, index) in projectList"
          :key="index"
          :class="{ disable: item.progress >= 1 }"
          @click="toDetail(item.id)"
        >
          <div class="header">
            <div class="title">
              <h3 class="name">{{ item.name }}</h3>
              <div class="type">{{ item.type }}</div>
            </div>
            <div class="progress-bar">
              <div
                class="bar"
                ref="progressBar"
                :style="{ width: `${item.progress * 100}%` }"
                v-if="item.progress < 1"
              ></div>
            </div>
          </div>
          <div class="content clearfix">
            <div class="rate-box box">
              <p class="rate">
                <span>{{ item.rate }}</span>
                <i>%</i>
              </p>
              <p class="text">约定年化借款利率</p>
            </div>
            <div class="limit-box box">
              <p class="month">
                <span>{{ item.limit }}</span>
                <i>个月</i>
              </p>
              <p class="text">项目期限</p>
            </div>
            <div class="remain-box box">
              <p class="money">{{ item.remain }}</p>
              <p class="text">剩余金额(元)</p>
            </div>
            <div class="invest-box box">
              <div class="btn" v-if="item.progress < 1">
                <p class="tips">联系客服立即购买</p>
                <p class="phone">客服热线: 10102015</p>
              </div>
            </div>
          </div>
        </li>
        <div class="pagination">
          <el-pagination
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :total="total"
            :page-size="10"
          ></el-pagination>
        </div>
      </template>
      <div class="no-data" v-else>暂无数据</div>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'project-list',
  data() {
    return {
      projectList: [
        // {
        //   id: 1,
        //   name: '', // 标的名称
        //   type: '鲸鱼优选', // 标的类型
        //   rate: '7.00', // 约定年化借款利率
        //   limit: 0, // 项目期限
        //   remain: '0.00', // 剩余金额
        //   progress: 0.0 // 投标进度
        // }
      ],
      loading: false,
      total: 0,
      currentPage: 1
    };
  },
  created() {
    this.requestList(this.currentPage);
  },
  methods: {
    toDetail(id) {
      this.$router.push({
        path: `/perfect-select/project-detail/${id}/${1}`
      });
    },
    handleCurrentChange() {
      this.requestList(this.currentPage);
    },
    async requestList(page) {
      this.loading = true;
      try {
        const res = await this.$http.post('/cg/commonRequest', {
          method: 'project.pc.list',
          token: '',
          page
        });
        if (res.code === 200) {
          this.projectList = res.data.list.map(item => {
            return {
              id: item.projectid,
              name: item.project_name,
              type: '鲸鱼优选',
              limit: item.period,
              rate: item.annual_rate,
              remain: (item.moneys - item.reduis_moneys)
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
              progress: parseFloat(item.reduis_moneys / item.moneys).toFixed(2)
            };
          });
          this.total = res.data.count;
          this.loading = false;
        } else {
          this.$message.error(res.code);
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.project-list-wrapper {
  width: 1200px;
  margin: 20px auto;
  .nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 88px;
    background: #fff;
    padding: 0 20px;
    .title {
      font-family: 'PingFangSC-Semibold';
      font-size: 20px;
      color: #000000;
      line-height: 30px;
      // vertical-align: middle;
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        margin: 0 20px 0 0;
      }
      i {
        display: inline-block;
        position: relative;
        padding: 0 30px 0 10px;
        background: #2c6eff;
        color: #fff;
        font-family: 'PingFangSC-Regular';
        font-size: 16px;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          right: -1px;
          // border-left: 10px solid transparent;
          border-right: 16px solid transparent;
          border-top: 16px solid #fff;
          transform: rotate(90deg);
        }
        &::after {
          content: '';
          position: absolute;
          right: -1px;
          bottom: 0;
          // border-left: 10px solid transparent;
          border-right: 16px solid transparent;
          border-top: 16px solid #fff;
          transform: rotate(180deg);
        }
      }
    }
    .more {
      font-family: 'PingFangSC-Regular';
      font-size: 22px;
      color: #2c6eff;
      line-height: 28px;
      cursor: pointer;
      .icon {
        font-size: 18px;
        margin-left: 4px;
      }
    }
  }
  .project-list {
    min-height: 300px;
    .project-item {
      margin-bottom: 20px;
      background: #fff url('https://files.jinr.com/jinr-index/img/bid-bg.png') no-repeat;
      background-position: 0 100%;
      transition: 0.2s linear;
      cursor: pointer;
      &:hover {
        box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.4);
      }
      .header {
        display: flex;
        height: 70px;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #e1e1e1;
        padding: 0 44px 0 20px;
        .title {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .name {
          font-family: 'PingFangSC-Medium';
          font-size: 18px;
          color: #333333;
          line-height: 18px;
        }
        .type {
          height: 26px;
          line-height: 26px;
          padding: 0 20px;
          margin: 0 10px;
          color: #2c6eff;
          text-align: center;
          border: 1px solid #2c6eff;
          border-radius: 15.5px;
        }
        // .remain-box {
        //   font-size: 0.24rem;
        // }
      }
      .content {
        height: 155px;
        .box {
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          height: 100%;
          font-family: 'PingFangSC-Medium';
          text-align: center;
          .text {
            font-family: 'PingFangSC-Regular';
            font-size: 16px;
            color: #696969;
            margin: 30px 0 0 0;
          }
        }
        .rate-box {
          float: left;
          width: 230px;
          .rate {
            color: #f65b48;
            span {
              font-size: 36px;
            }
            i {
              font-size: 26px;
            }
          }
        }
        .limit-box {
          float: left;
          width: 200px;
          margin: 0 0 0 20px;
          .month {
            color: #f65b48;
            span {
              font-size: 36px;
            }
            i {
              font-size: 26px;
            }
          }
        }
        .invest-box {
          float: right;
          width: 260px;
          margin-right: 36px;
          .btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 0 10px;
            height: 68px;
            background: #2c6eff;
            border-radius: 8px;
            text-align: center;
            // line-height: 68px;
            font-family: 'PingFangSC-Regular';
            font-size: 22px;
            color: #ffffff;
            cursor: pointer;
            .tips {
              font-size: 18px;
            }
            .phone {
              font-size: 14px;
            }
          }
        }
      }
    }
    .project-item.disable {
      background: #fff;
      .type {
        color: #696969;
        border-color: #696969;
      }
      .text {
        color: #696969;
      }
      .rate-box {
        .rate {
          color: #696969;
        }
      }
      .limit-box {
        .month {
          color: #696969;
        }
      }
      .invest-box {
        background: url('https://files.jinr.com/jinr-index/img/bid-full.png') no-repeat center;
        background-size: 60%;
      }
    }
    .pagination {
      margin: 0 auto;
      display: flex;
      justify-content: center;
    }
    .no-data {
      text-align: center;
      font-size: 30px;
      line-height: 300px;
      color: #ccc;
      background: #fff;
    }
  }
}
</style>
